import { Box, Step, Stepper, Typography, StepLabel } from "@mui/material";

interface BOHeaderProps {
  title: string;
  subTitle: string;
  activeStep: number;
  steps: string[];
  titleVariant?: "h4" | "h5" | "h6";
}

const BOHeader = ({
  title,
  subTitle,
  activeStep,
  steps,
  titleVariant = "h4",
}: BOHeaderProps) => {
  return (
    <Box
      display={"flex"}
      justifyContent={"space-between"}
      alignItems={"center"}
      marginBottom={3}
    >
      <Box>
        <Typography
          variant={titleVariant}
          fontWeight={600}
          color="text.primary"
        >
          {title}
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{ marginTop: "8px" }}
          fontWeight={500}
          color="text.secondary"
        >
          {subTitle}
        </Typography>
      </Box>

      <Box width="30%">
        <Stepper activeStep={activeStep}>
          {steps.map((label, index) => {
            const stepProps: { completed?: boolean } = {};
            const labelProps: {} = {};
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>
                  <Typography
                    variant="subtitle2"
                    color={`${
                      stepProps.completed || activeStep >= index
                        ? "primary"
                        : "text.secondary"
                    }`}
                  >
                    {label}
                  </Typography>
                </StepLabel>
              </Step>
            );
          })}
        </Stepper>
      </Box>
    </Box>
  );
};

export default BOHeader;
